import { render, staticRenderFns } from "./ErrorPageDetails.vue?vue&type=template&id=44172daa&scoped=true"
import script from "./ErrorPageDetails.vue?vue&type=script&lang=ts"
export * from "./ErrorPageDetails.vue?vue&type=script&lang=ts"
import style0 from "./ErrorPageDetails.vue?vue&type=style&index=0&id=44172daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44172daa",
  null
  
)

export default component.exports